import { jsx as _jsx } from "react/jsx-runtime";
export function CatalogGrid({ children, columns = { default: 1, sm: 2, lg: 3, xl: 4 }, }) {
    const gridClasses = [
        columns.default && `grid-cols-${columns.default}`,
        columns.sm && `sm:grid-cols-${columns.sm}`,
        columns.md && `md:grid-cols-${columns.md}`,
        columns.lg && `lg:grid-cols-${columns.lg}`,
        columns.xl && `xl:grid-cols-${columns.xl}`,
    ]
        .filter(Boolean)
        .join(" ");
    return (_jsx("div", { className: `grid ${gridClasses} gap-6`, children: children }));
}
